import API from "../API";
import { AxiosResponse } from "axios";

type SignupPayload = {
  name: string;
  entityName?: string;
  email: string;
  phone: string;
  subtype: string;
};

export const signup = (payload: SignupPayload): Promise<AxiosResponse> => {
  return API.post("/auth/register", payload);
};

type PasswordRequestPayload = {
  email: string;
  role: string;
};

export const passwordRequest = async (
  payload: PasswordRequestPayload
): Promise<AxiosResponse> => {
  return API.post("/auth/password/request", payload);
};

type ValidationCodePayload = {
  email: string;
  code: string;
  state: string;
  role: string;
};

export const validateCode = async (
  payload: ValidationCodePayload
): Promise<AxiosResponse> => {
  return API.post("/auth/password/validate", payload);
};

type ChangePasswordPayload = {
  email: string;
  password: string;
  state: string;
  role: string;
};

export const changePassword = async (
  payload: ChangePasswordPayload
): Promise<AxiosResponse> => {
  return API.post("/auth/password/change", payload);
};

type LoginPayload = {
  email: string;
  password: string;
  role: string;
};

export const login = async (payload: LoginPayload): Promise<AxiosResponse> => {
  return API.post("/auth/login", payload);
};
